import { render } from "./ManageCountry.vue?vue&type=template&id=05508f19&scoped=true"
import script from "./ManageCountry.js?vue&type=script&lang=js"
export * from "./ManageCountry.js?vue&type=script&lang=js"

import "./ManageCountry.vue?vue&type=style&index=0&id=05508f19&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05508f19"]])

export default __exports__